<template>
  <div>
    <b-card class="m-3" no-body>
      <template #header>
        <h6 class="mb-0 text-center titulo-sagres font-weight-bold">
          Relatório Receita Corrente Líquida
        </h6>
      </template>
      <b-form v-if="!blockForm" class="m-2" @submit.stop.prevent="gerarRelatorio">
        <b-row>
          <b-col cols="12" xl="2">
            <b-form-group id="input-group-exercicio" label="Exercício *" label-for="input-exercicio"
              label-class="text-left">
              <b-form-select id="input-exercicio" v-model="filtros.exercicio" :options="exercicios"
                :disabled="desabilitarExercicios || loading" @change="prepararRCL()"></b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="12" xl="2">
            <b-form-group id="input-group-mes" label="Mês Referência *" label-for="input-mes" label-class="text-left">
              <b-form-select id="input-mes" v-model="filtros.mes" :options="mesesDisponiveis"
                :disabled="desabilitarRCL || loading"></b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="12" xl="8" class="d-flex align-items-center justify-content-end">
            <b-button class="mr-2" size="md" variant="secondary" type="submit"
              :disabled="desabilitarRCL || loading || !filtrosPreenchidos">
              <font-awesome-icon icon="file-alt" class="mr-2" />
              Gerar Relatório
            </b-button>
          </b-col>
        </b-row>
      </b-form>
      <div v-else class="text-center">
        <b-spinner label="Carregando..."></b-spinner>
      </div>
    </b-card>
    <div v-if="loading" class="text-center">
      <b-spinner label="Carregando..."></b-spinner>
    </div>
    <pdf-viewer v-if="!loading && pdfData" :data="pdfData" :filename="filename" />
  </div>
</template>

<script>
import reportService from '@/services/reportService'
import PdfViewer from "@/components/PdfViewer.vue"
import { UtilsTS } from '@/utilsts'
import { FiltrosGestao } from '@/types/relatorios/filtros-gestao'

export default {
  mixins: [UtilsTS],
  components: {
    PdfViewer
  },
  data() {
    return {
      filename: null,
      pdfData: null,
      desabilitarRCL: false,
      desabilitarExercicios: false,
      meses: [],
      mesesDisponiveis: [],
      exercicios: [],
      filtros: {
        exercicio: null,
        mes: null,
        ug: null,
      },
      nomeUgLogado: null,
      loading: false,
      blockForm: false,
    }
  },
  computed: {
    filtrosPreenchidos() {
      return this.filtros.exercicio != null && this.filtros.mes != null
    }
  },
  methods: {
    async getExercicios() {
      this.blockForm = true
      const response = await reportService.getExerciciosRCL()
      if (response && response.status == 200) {
        this.desabilitarExercicios = response.data.desabilitarExercicios
        this.desabilitarRCL = response.data.desabilitarRCL
        if (!this.desabilitarExercicios) {
          this.exercicios = [{ value: null, text: "Selecione" }, ...response.data.exercicios.map(e => {
            return { value: e, text: e }
          })]
        }
        else if (response.data.msg) {
          this.$toast.error(response.data.msg)
        }
      }
      else if (response && response.data.msg)
        this.$toast.error(response.data.msg)
      else {
        this.$toast.error('erro ao preparar relatório')
      }
      this.blockForm = false
    },

    async prepararRCL() {
      this.desabilitarRCL = true
      this.blockForm = true
      const response = await reportService.prepararRCL(this.filtros.exercicio)
      if (response && response.status == 200) {
        this.desabilitarRCL = response.data.desabilitarRCL
        if (!this.desabilitarRCL) {
          const ultimoMes = response.data.ultimoMes
          this.mesesDisponiveis = this.meses.filter(m => m.value <= ultimoMes)
          this.filtros.mes = this.mesesDisponiveis[0].value
          this.filtros.ug = response.data.codigoUG
          this.filtros.idArea = response.data.idArea
          this.nomeUgLogado = response.data.nomeUG
        }
        else if (response.data.msg) {
          this.$toast.error(response.data.msg)
        }
      }
      else if (response && response.data.msg)
        this.$toast.error(response.data.msg)
      else {
        this.$toast.error('Erro ao preparar relatório')
      }
      this.blockForm = false
    },

    async gerarRelatorio() {
      try {
        this.pdfData = null;
        this.loading = true;
        const ftr = new FiltrosGestao()
        ftr.exercicio = this.filtros.exercicio
        ftr.mes = this.filtros.mes
        ftr.ug = this.filtros.ug
        const response = await reportService.getRelatorioGestao('ReceitaCorrenteLiquida', ftr)
        this.filename = "ReceitaCorrenteLiquida_" + this.filtros.exercicio + "_" + this.filtros.mes + "_" + this.filtros.ug;
        const blob = this.base64ToPdf(response.ArquivoPdf)
        const objectUrl = URL.createObjectURL(blob)
        this.pdfData = objectUrl;
      } catch (e) {
        this.tratarError(e)
      } finally {
        this.loading = false;
      }
    }
  },

  async mounted() {
    this.meses = this.getListaMeses()
    await this.getExercicios()
  }

}
</script>

<style>
#cardFiltros {
  text-align: left;
  margin: 20px auto !important;
  width: 95%;
}
</style>